export default __webpack_public_path__ + "static/image2-32a27a273c4710b40f93a7bf90650118.jpg";